import React from "react";
import { WeightSemiBold } from "../../../WeightSemiBold/WeightSemiBold";
import FrontHeaderSwirve from "../../../../../src/assets/FrontHeaderSwirve";
import FrontTitleHeader from "../FrontTitleHeader/FrontTitleHeader";
import { FrontTextColour } from "../../../FrontTextColour/FrontTextColour";

type TFrontHeaderWidth = "page" | "content";

type TFrontHeaderTitleHeading = "h1";

type TFrontHeader = {
    backLink?: {
        label: string;
        url: string;
    };
    pill?: JSX.Element;
    width?: TFrontHeaderWidth;
    titleHeading?: TFrontHeaderTitleHeading;
    // Rendered under the title inside the band. The listing page puts its price and
    // tenure here so the band earns its height instead of carrying one line of address.
    meta?: JSX.Element;
};

export class FrontHeader extends React.Component<React.PropsWithChildren<TFrontHeader>> {
    public render (): JSX.Element {
        return (
            <div className="front-header">
                {/* TITLE */}
                <div className={
                    "front-header__body" +
                    (this.props.backLink !== undefined ? " front-header__body--with-back-link" : "")
                }>
                    <div className={
                        "front-header__title" +
                        (this.props.width === "content" ? " front-header__title--content-width" : "")
                    }>
                        {this.props.backLink !== undefined &&
                            <a className="front-header__back-link" href={this.props.backLink.url}>
                                &lsaquo; {this.props.backLink.label}
                            </a>
                        }
                        {this.props.pill !== undefined &&
                            <div className="front-header__pill">
                                {this.props.pill}
                            </div>
                        }
                        <FrontTitleHeader heading={this.props.titleHeading}>
                            <WeightSemiBold>
                                <FrontTextColour colour="neutral-18">
                                    {this.props.children}
                                </FrontTextColour>
                            </WeightSemiBold>
                        </FrontTitleHeader>
                        {this.props.meta !== undefined &&
                            <div className="front-header__meta">
                                {this.props.meta}
                            </div>
                        }
                    </div>
                </div>
                {/* SWIRVE */}
                <FrontHeaderSwirve className="front-header__swirve" />
            </div>
        );
    }
}
